import { useEffect, useRef } from "react";

export const usePolling = (
  callback: VoidFunction,
  interval: number,
  shouldPoll: boolean
) => {
  const intervalIdRef = useRef<NodeJS.Timer | null>(null);

  useEffect(() => {
    if (shouldPoll) {
      intervalIdRef.current = setInterval(callback, interval);
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, [callback, interval, shouldPoll]);

  useEffect(() => {
    if (!shouldPoll && intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  }, [shouldPoll]);
};
